/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Transfer_Success_NoneInputs */



/**
* | output |
* | --- |
* | "Nothing needed transferring — this member holds no shared spaces or projects." |
*
* @param {Member_Transfer_Success_NoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_transfer_success_none = /** @type {((inputs?: Member_Transfer_Success_NoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Transfer_Success_NoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Es musste nichts übertragen werden — dieses Mitglied hat keine geteilten Spaces oder Projekte.")
	return /** @type {LocalizedString} */ ("Nothing needed transferring — this member holds no shared spaces or projects.")
});